import { z } from 'zod';

export const DsMatchSummaryStatuses = [
  'Requested',
  'Received',
  'Failed',
] as const;

const DsMatchSummaryDataSchema = z.object({
  fitDecision: z.string(),
  topMatchPoints: z.array(z.string()),
  concerns: z.array(z.string()),
  evidence: z.array(z.string()),
  clientSubmissionDraft: z.string(),
});

const DsMatchSummaryErrorSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
});

export const DsMatchSummarySchema = z.object({
  status: z.enum(DsMatchSummaryStatuses),
  data: DsMatchSummaryDataSchema.nullable().optional(),
  requestedAt: z.string().nullable().optional(),
  receivedAt: z.string().nullable().optional(),
  failedAt: z.string().nullable().optional(),
  error: DsMatchSummaryErrorSchema.nullable().optional(),
});

export type DsMatchSummary = z.infer<typeof DsMatchSummarySchema>;
